import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarSubHeading from "./component";

const mapStateToProps = ({
    variants,
    registrationStates

}) => ({
    variants,
    registrationStates
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarSubHeading);
